export default __webpack_public_path__ + "static/media/ITRealCase2-moblie.7d12165a.jpg";